import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const connectorRedirectUri = (provider) => `${window.location.origin}/connectors/${provider}/callback`;

export default function ConnectorCallback() {
  const { provider } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(params.get("error_description") || params.get("error"));
  useEffect(() => {
    if (error) return;
    const orgId = sessionStorage.getItem("ch_connector_org");
    api.post(`/orgs/${orgId}/connectors/${provider}/callback`, { code: params.get("code"), state: params.get("state"), redirect_uri: connectorRedirectUri(provider) })
      .then(() => { toast.success("Drive connected"); navigate(`/org/${orgId}/evidence`, { replace: true }); })
      .catch((e) => setError(errMsg(e)));
    // eslint-disable-next-line
  }, []);
  return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="connector-callback">{error ? <span className="text-rose-600">{error}</span> : `Connecting ${provider}…`}</div>;
}
